import { Component, inject } from '@angular/core';
import { PipelinePlannedPlantationPlantService } from '../proxy/operational/controllers';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PipelinePlannedPlantationPlantCreateDto,
  PipelinePlannedPlantationPlantUpdateDto,
} from '../proxy/operational/dtos/pipeline-planned-plantation-plant';
import { PIPELINEPLANNEDPLANTATIONPLANT_CONFIG, PIPELINEPLANNEDPLANTATIONPLANT_FIELDS } from './pipeline-planned-plantation-plant.config';
import { BaseHierarchicalCrudComponent, GenericForm, ICrudService, ZnHierarchicalViewComponent } from '@zendra/shared';
import { PipelinePlannedPlantationPlantPlanningOrchestratorService } from 'orchestrator/proxy';
import {
  GetPipelinePlannedPlantationPlantProjectionListInputDto,
  PipelinePlannedPlantationPlantProjectionDto,
  PipelinePlannedPlantationPlantProjectionExcelDownloadDto,
} from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/pipeline-planned-plantation-plants/models';

@Component({
  selector: 'app-pipeline-planned-plantation-plant',
  imports: [
    ZnHierarchicalViewComponent,
    GenericForm,
  ],
  providers: [ListService, PipelinePlannedPlantationPlantService, ConfirmationService],
  templateUrl: './pipeline-planned-plantation-plant.html',
  styleUrl: './pipeline-planned-plantation-plant.scss',
})
export class PipelinePlannedPlantationPlant extends BaseHierarchicalCrudComponent<
  PipelinePlannedPlantationPlantProjectionDto,
  PipelinePlannedPlantationPlantCreateDto,
  PipelinePlannedPlantationPlantUpdateDto,
  PipelinePlannedPlantationPlantProjectionExcelDownloadDto
> {
  operationalService = inject(PipelinePlannedPlantationPlantService);
  orchestratorService = inject(PipelinePlannedPlantationPlantPlanningOrchestratorService);
  service: ICrudService<
    PipelinePlannedPlantationPlantProjectionDto,
    PipelinePlannedPlantationPlantCreateDto,
    PipelinePlannedPlantationPlantUpdateDto,
    PipelinePlannedPlantationPlantProjectionExcelDownloadDto
  > = {
    create: input => this.operationalService.create(input),
    update: (id, input) => this.operationalService.update(id, input),
    deleteByIds: ids => this.operationalService.deleteByIds(ids),
    getList: (query: GetPipelinePlannedPlantationPlantProjectionListInputDto) =>
      this.orchestratorService.getList(query),
    getDownloadToken: () => this.orchestratorService.getDownloadToken(),
    getListAsExcelFile: input => this.orchestratorService.getListAsExcelFile(input),
    projectionConsistency: this.createProjectionConsistency(
      this.orchestratorService,
      'pipelinePlannedPlantationPlantId',
    ),
  };
  config = PIPELINEPLANNEDPLANTATIONPLANT_CONFIG;
  fields = PIPELINEPLANNEDPLANTATIONPLANT_FIELDS;

  protected override prepareCreateDto(data: PipelinePlannedPlantationPlantCreateDto): PipelinePlannedPlantationPlantCreateDto {
    return {
      ...data,
      pipelinePlannedPlantationId: this.parentId ?? data.pipelinePlannedPlantationId,
    };
  }

  protected prepareUpdateDto(data: any, selected: PipelinePlannedPlantationPlantProjectionDto): PipelinePlannedPlantationPlantUpdateDto {
    const fromDataOrSelected = <T>(key: string, fallback: T) =>
      data[key] === undefined ? fallback : data[key];

    return {
      pipelinePlannedPlantationId: selected.pipelinePlannedPlantationId ?? 0,
      plantId: fromDataOrSelected('plantId', selected.plantId ?? null),
      plantTypeId: fromDataOrSelected('plantTypeId', selected.plantTypeId ?? null),
      speciesGroupId: fromDataOrSelected('speciesGroupId', selected.speciesGroupId ?? 0),
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PipelinePlannedPlantationPlant';
  }
}
